module.exports = __webpack_public_path__ + "static/media/Double_decker_image.297ecfa8.jpg";